import $ from 'jquery';
import container from '../container/container';
import preloader from "../preloader/preloader";
import jqueryTransit from 'jquery.transit';
import _ from 'underscore';

const loadMore = function (id) {

    let publicVars = {};

    const privateVars = {
        name: 'load-more(' + id + ')',
        itemsAll: false,
        itemsLoading: false,
        itemsCanBeAdded: true,
        itemCurrentRest: 0,
        itemWasLoaded: false,

        callbacks: {
            addParamCallback: null,
            successCallback: null
        }
    };


    const privateMethods = {
        prepareObj: function (options) {

            publicVars = container.performCopy(publicVars, options);

            privateMethods.bind();

            privateMethods.startup();

        },

        startup: function () {
            privateMethods.setCurrentItemsNumber(true);

            if (publicVars.itemsCount <= publicVars.itemsLimit) {
                privateVars.itemsAll = true;
            } else {
                privateMethods.fireGetMoreItemsAction(100);
            }
        },
        bind: function () {
            container.msg(privateVars.name, 'module started');

            $(window).scroll(function () {

                var ticking = false;

                if (!ticking) {
                    window.requestAnimationFrame(function () {
                        privateMethods.fireGetMoreItemsAction(100);
                        ticking = false;
                    });
                }
                ticking = true;

            });

            $(window).resize(function () {
                privateMethods.setCurrentItemsNumber(false);
                privateMethods.fireGetMoreItemsAction();
            });

            $(window).on("orientationchange", function () {
                privateMethods.setCurrentItemsNumber(false);
                privateMethods.fireGetMoreItemsAction();
            });

            $(publicVars.cssId.loadMoreBtnId).click(function () {
                privateMethods.getMoreItems(0, false);
            });
        },

        getMoreItems: () => {
            if (!privateVars.itemsAll && !privateVars.itemsLoading) {
                privateVars.itemsLoading = true;

                $(publicVars.cssId.loadMoreBtnWrapperId).css({opacity: 0, visibility: 'hidden'});

                $(publicVars.cssId.loadMoreLoaderId).css({display: 'block', opacity: 0});
                $(publicVars.cssId.loadMoreLoaderId).transit({opacity: 1}, 300, () => {
                    privateMethods.modelGetMoteItems(publicVars.itemsLimit);
                });
            }
        },

        modelGetMoteItems: (limit) => {

            let offset = $(publicVars.cssId.itemWrapperCls).length;

            if (publicVars.limitItemsTab && publicVars.limitItemsTab.length > 0) {
                offset = $(publicVars.cssId.itemWrapperCls).length - privateVars.itemCurrentRest;
            }

            let addParam = '';

            if (publicVars.additionalParam && typeof privateVars.callbacks.addParamCallback === 'function') {
                if (privateVars.callbacks.addParamCallback() !== '') {
                    addParam = '/' + privateVars.callbacks.addParamCallback();
                }
            }

            $.ajax({
                url: publicVars.ajaxMoreItemsEndpoint + '/' + offset + '/' + limit + addParam,
                type: 'GET',
                data: {}
            }).done(function (data) {
                if(publicVars.preloadImages) {
                    const currentTimestamp = new Date().getTime();
                    preloader.setPreloadBulk(privateVars.name + currentTimestamp, data.items_images);

                    preloader.getPreloadBulkFinished(privateVars.name + currentTimestamp, function() {
                        privateMethods.actionShowMoreItems(data);
                    });
                } else {
                    privateMethods.actionShowMoreItems(data);
                }
            });
        },

        actionShowMoreItems: (data) => {

            if (privateVars.itemsCanBeAdded) {
                const compiled = _.template($(publicVars.cssId.templateId).html());

                const output = compiled({
                    data: data
                });

                publicVars.itemsCount = parseInt(data.count_all);

                $(publicVars.cssId.itemWrapperCls).each(function () {
                    if ($(this).css('display') == 'none') {
                        $(this).remove();
                    }
                });

                $(publicVars.cssId.wrapperCls).append(output);

                const newCount = $(publicVars.cssId.itemWrapperCls).length;

                if (privateVars.callbacks.successCallback !== null) {
                    privateVars.callbacks.successCallback(data, newCount);
                }

                if (publicVars.itemsCount <= newCount) {
                    privateVars.itemsAll = true;

                    $(publicVars.cssId.loadMoreLoaderId).removeAttr('style');
                    $(publicVars.cssId.loadMoreWrapperId).addClass(publicVars.cssId.loadMoreAllLoadedCls.substr(1));

                } else {
                    $(publicVars.cssId.loadMoreBtnWrapperId).css({opacity: 0, visibility: 'visible'});
                    $(publicVars.cssId.loadMoreLoaderId).removeAttr('style');
                    $(publicVars.cssId.loadMoreBtnWrapperId).transit({opacity: 1}, 300, () => {
                    });
                }

                $(publicVars.cssId.itemCls + publicVars.cssId.isAddedCls).css({opacity: 0});

                $(publicVars.cssId.itemCls + publicVars.cssId.isAddedCls).transit({opacity: 1}, 700, function () {
                    $(publicVars.cssId.itemCls + publicVars.cssId.isAddedCls).removeClass(publicVars.cssId.isAddedCls.substr(1));
                });

                privateVars.itemsLoading = false;
                privateVars.itemWasLoaded = true;
                privateVars.itemCurrentRest = 0;
            } else {
                privateVars.itemsLoading = false;
            }
        },

        disable: () => {
            privateVars.itemsLoading = true;
            privateVars.itemsCanBeAdded = false;
        },

        enable: (data) => {
            privateVars.itemsAll = false;
            privateVars.itemsLoading = false;
            privateVars.itemsCanBeAdded = true;
            privateVars.itemWasLoaded = false;

            publicVars.itemsCount = parseInt(data.count_all);

            if (publicVars.itemsCount <= publicVars.itemsLimit) {
                privateVars.itemsAll = true;
                $(publicVars.cssId.loadMoreWrapperId).addClass(publicVars.cssId.loadMoreAllLoadedCls.substr(1));
                $(publicVars.cssId.loadMoreBtnWrapperId).css({opacity: 0, visibility: 'hidden'});
            } else {
                $(publicVars.cssId.loadMoreWrapperId).removeClass(publicVars.cssId.loadMoreAllLoadedCls.substr(1));
                $(publicVars.cssId.loadMoreBtnWrapperId).removeAttr('style');
                privateMethods.fireGetMoreItemsAction();
            }
        },

        fireGetMoreItemsAction: (modifier = 0, auto = true) => {

            if (publicVars.autoLoad === auto && !privateVars.itemsAll) {
                const loadMoreOffset = $(publicVars.cssId.loadMoreWrapperId).offset();

                if ($(window).scrollTop() + $(window).height() + modifier > loadMoreOffset.top) {
                    privateMethods.getMoreItems();
                }
            }
        },

        setAdditionalParamCallback: (paramCallback) => {
            privateVars.callbacks.addParamCallback = paramCallback;
        },


        setSuccessCallback: (successCallback) => {
            privateVars.callbacks.successCallback = successCallback;
        },

        setCurrentItemsNumber: function (startup = false) {
            if (publicVars.limitItemsTab && publicVars.limitItemsTab.length > 0) {
                for (var i = 0; i < publicVars.limitItemsTab.length; i++) {

                    if (window.matchMedia('(min-width: ' + publicVars.limitItemsTab[i]['min'] + 'px) and (max-width: ' + publicVars.limitItemsTab[i]['max'] + 'px)').matches) {
                        publicVars.itemsLimit = publicVars.limitItemsTab[i]['limit'];

                        if (publicVars.limitItemsTab[i]['cls']) {
                            $(publicVars.limitItemsTab[i]['cls']).remove();
                        }

                        if (!startup && !privateVars.itemsAll) {
                            let rest = $(publicVars.cssId.itemWrapperCls).length % publicVars.limitItemsTab[i]['limitBase'];
                            privateVars.itemCurrentRest = rest;

                            $(publicVars.cssId.itemWrapperCls).css('display', 'block');

                            let count = 0;
                            $($(publicVars.cssId.itemWrapperCls).get().reverse()).each(function () {
                                if (count < rest) {
                                    $(this).css('display', 'none');
                                    count++;
                                } else {
                                    return;
                                }
                            });
                        }

                    }
                }
            }

        },

        overrideOffsetLimit: (limit) => {
            publicVars.itemsLimit = limit;

            privateVars.itemsAll = false;
            privateVars.itemsLoading = false;
            privateVars.itemsCanBeAdded = true;

            if (publicVars.itemsCount <= publicVars.itemsLimit) {
                privateVars.itemsAll = true;
                $(publicVars.cssId.loadMoreWrapperId).addClass(publicVars.cssId.loadMoreAllLoadedCls.substr(1));
            } else {
                $(publicVars.cssId.loadMoreWrapperId).removeClass(publicVars.cssId.loadMoreAllLoadedCls.substr(1));
                privateMethods.fireGetMoreItemsAction();
            }
        },

        reset: (itemsCount) => {
            privateVars.itemsAll = false;
            privateVars.itemsLoading = false;
            privateVars.itemsCanBeAdded = true;
            privateVars.itemCurrentRest = 0;
            privateVars.itemWasLoaded = false;

            publicVars.itemsCount = itemsCount;

            privateMethods.setCurrentItemsNumber(true);

            if (publicVars.itemsCount <= publicVars.itemsLimit) {
                privateVars.itemsAll = true;
                $(publicVars.cssId.loadMoreWrapperId).addClass(publicVars.cssId.loadMoreAllLoadedCls.substr(1));
            } else {
                $(publicVars.cssId.loadMoreWrapperId).removeClass(publicVars.cssId.loadMoreAllLoadedCls.substr(1));
            }
        }
    };

    return {
        init: function (options) {
            privateMethods.prepareObj(options);
        },
        disable: function () {
            privateMethods.disable();
        },
        enable: function (data) {
            privateMethods.enable(data);
        },
        setAdditionalParamCallback: function (paramCallback) {
            privateMethods.setAdditionalParamCallback(paramCallback);
        },
        setSuccessCallback: function (successCallback) {
            privateMethods.setSuccessCallback(successCallback);
        },
        overrideOffsetLimit: function (limit) {
            privateMethods.overrideOffsetLimit(limit);
        },
        reset: function (itemsCount) {
            privateMethods.reset(itemsCount);
        }
    };
};

const factory = {
    objId: 0,
    /**
     * Get load more
     *
     */
    create: function () {
        factory.objId++;

        return loadMore(factory.objId);
    }
};

export default {
    create: factory.create
}


/*

 */
